import { PayloadAction } from "@reduxjs/toolkit";
import { createSearchParams } from "react-router-dom";
import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import routeSlice, { Route } from "./slice";

type RouteResponse = ApiResponse<{ data: Route[] }>;

export type RouteRequest = {
  departure_country_id: string;
  arrival_country_id: string;
};

function* routeSaga() {
  yield takeLatest(routeSlice.actions.fetchData, handleFetchData);
}

function* handleFetchData({ payload }: PayloadAction<RouteRequest>) {
  const params = createSearchParams(payload).toString();

  const response: RouteResponse = yield call(fetchAPI, `/routes?${params}`);

  if (response && response.data) {
    yield put(routeSlice.actions.setData(response.data));
  }

  yield put(routeSlice.actions.setIsLoading(false));
}

export default routeSaga;
